import "bootstrap/dist/css/bootstrap.min.css";
import AddUpdateForm from "../../../Components/AddUpdateForm";
import { Breadcrumb, Button } from "react-bootstrap";
import FieldDescription from "../../../Components/FieldDescription";
import { useState } from "react";
import { Concentration } from "../../../Model/Setting/Concentration";
import { useParams } from "react-router-dom";
interface AddUpdateProps {
  title?: any;
  listRoute?: any;
  isNotUpdate?: any;
  onChangeModalStatus?: (status: boolean) => void;
}

const AddUpdate: React.FC<AddUpdateProps> = ({
  title,
  listRoute,
  isNotUpdate,
  onChangeModalStatus,
}) => {
  const [isShows, setIsShows] = useState<boolean>(false);
  const { id } = useParams();
  const formFields = [
    {
      id: "inputName",
      label: "Name*",
      type: "text",
      col: 12,
      name: "name",
      placeholder: "Enter Name",
      validate: [
        {
          rule: (value: any) => !!value,
          message: "Name is required",
        },
      ],
      description: "Enter the name of the product Concentration.",
    },
  ];
  const handleHelpButtonClick = () => {
    setIsShows(!isShows);
    const formBottom = document.getElementById("form-bottom");
    if (formBottom) {
      formBottom.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };
  return (
    <>
      <Breadcrumb>
        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
        <Breadcrumb.Item href="/concentration">Concentration</Breadcrumb.Item>
        <Breadcrumb.Item active className="fw-bold">
          {!id ? "Add Concentration" : "Edit Concentration"}
        </Breadcrumb.Item>
      </Breadcrumb>
      <div>
        <span style={{ float: "inline-end" }}>
          <Button variant="outline-secondary" onClick={handleHelpButtonClick}>
            Need Help?
          </Button>
        </span>
        <AddUpdateForm
          formFields={formFields}
          model={Concentration}
          title={title}
          listRoute={listRoute}
          autoUpdateField={true}
          isNotUpdate={isNotUpdate}
          onChangeModalStatus={onChangeModalStatus}
        />
      </div>
      <div id="form-bottom">
        <FieldDescription
          title={title}
          formFields={formFields}
          isShows={isShows}
        />
      </div>
    </>
  );
};

export default AddUpdate;
